import React from 'react';
import { Alert } from 'react-bootstrap';

const VARIANTS = {
  READY: 'success',
  MOVING: 'warning',
  DRYING: 'warning',
  LOADING: 'warning',
  DISABLED: 'danger',
};

// Remove underscores and hyphens, capitalise the first letter of each word.
const formatLabel = (value = '') =>
  value
    .replaceAll(/[_-]+/gu, ' ')
    .trim()
    .replaceAll(/\b\w/gu, (char) => char.toUpperCase());

export default function EquipmentState(props) {
  const { state, equipmentName } = props;

  return (
    <Alert
      style={{
        margin: 0,
        width: 'inherit',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
      variant={VARIANTS[state] || 'danger'}
    >
      {formatLabel(equipmentName)} <b>{state}</b>
    </Alert>
  );
}
